/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import get from 'lodash/get';
import { useRouter } from 'next/router';
import { makeStyles } from 'src/makeStyles';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import route from '../../constants/routes';
import ListingExpandableCard from '../../components/ListingExpandableCard';
import FbCircularProgress from '../../components/FbCircularProgress';
import { useList } from '../../utils/crudUtils';
import FbPagination from '../../components/FbPagination';
import { selectComposersList } from './selectors';
import ComposerSearchFilter from '../../components/ComposerSearchFilter';
import { getDynamicRoutePropsWithAction, getRouteWithSlug } from '../../utils/common';
import ListingPageLayout from '../../components/ListingPageLayout';
import { TP } from '../../constants/consts';

const useStyles = makeStyles()(theme => ({
  wrapper: {
    width: '100%',
  },
  cardWrapper: {
    width: '100%',
  },
  titledLink: {
    paddingRight: '40px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '20px',
    },
  },
}));

const Composers = ({
  t,
  composerList,
  loadingComposersList,
  onChangePage,
  submitFunc,
  customBreadcrumbs,
  disableQuery,
  pageQueryList,
}) => {
  const { classes, cx } = useStyles();
  const router = useRouter();
  const query = router.query?.letter || router.query?.query;

  const [filteredComposers, pagination] = useList(composerList);

  const labels = {
    company: {
      title: `${TP}.m_COMPOSER`,
      property: 'fullName',
      linkProps: source => getDynamicRoutePropsWithAction(`${route.ARTISTS}`, source),
    },
  };

  // eslint-disable-next-line array-callback-return

  const searchFiltersComponent = <ComposerSearchFilter t={t} submitFunc={submitFunc} />;

  const composers = (
    // eslint-disable-next-line react/jsx-fragments
    <React.Fragment>
      <Grid container spacing={2} className={classes.wrapper}>
        {loadingComposersList ? (
          <FbCircularProgress />
        ) : (
          filteredComposers.map(composer => {
            // productions && productions.filter(prod => get(prod, 'company.id') === get(seasonCompany, 'company.id')).reverse();
            const updatedComposer = { ...composer };
            updatedComposer.fullName = `${get(composer, 'firstName')} ${get(composer, 'lastName')}`;
            return (
              <ListingExpandableCard
                t={t}
                key={updatedComposer.id}
                source={updatedComposer}
                labels={labels}
                detailsLinkProps={{
                  href: `${route.ARTISTS}/[id]/[[...action]]`,
                  as: getRouteWithSlug(route.ARTISTS, updatedComposer),
                }}
                viewDetailsText={`${t('operabase.general.LIST_CARD_DETAILS')}`}
              />
            );
          })
        )}
      </Grid>
      {!loadingComposersList && <FbPagination filters={pagination} fetchFunction={onChangePage} />}
    </React.Fragment>
  );

  return (
    <ListingPageLayout
      title={t(`operabase.general.m_COMPOSERS`)}
      subTitle={t(`operabase.general.FIND_COMPOSERS_BY_NAME`)}
      content={composers}
      seo={{
        title: t(`operabase.general.m_COMPOSERS`),
        ogTitle: t('operabase.general.m_COMPOSERS'),
        other: {
          noindex: !!query,
          follow: !!query,
        },
      }}
      contentDivider={false}
      searchFiltersComponent={searchFiltersComponent}
      customBreadcrumbs={customBreadcrumbs}
      disableQuery={disableQuery}
      pageQueryList={pageQueryList}
    />
  );
};

Composers.propTypes = {
  t: PropTypes.func.isRequired,
  onChangePage: PropTypes.func,
  submitFunc: PropTypes.func,
  loadingComposersList: PropTypes.bool,
  composerList: PropTypes.array,
};

Composers.defaultProps = {
  loadingComposersList: false,
};

const mapStateToProps = createStructuredSelector({
  composerList: selectComposersList(),
});

const withConnect = connect(mapStateToProps, null);

export default withConnect(Composers);
